var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KnowledgeList',{attrs:{"pre-defined-keyword":_vm.$route.params.keyword,"hidden-columns":['approvalStatus']}})}
var staticRenderFns = []

export { render, staticRenderFns }